import React, { useState } from 'react';

const Message = () => {
  const [activeTab, setActiveTab] = useState('status');

  const handleSearchClick = () => {
    
    // Placeholder for navigation or API call
  };

  const tabs = [
    { id: 'status', label: 'Status' },
    { id: 'unread', label: 'Unread' },
    { id: 'users', label: 'Users' },
    { id: 'service', label: 'Service' },
  ];

  return (
    <div className="bg-[#FFF6F1] min-h-screen p-4 sm:p-6 lg:p-8">
      {/* <h1 className="text-[#1B4582] text-2xl sm:text-3xl font-bold mb-6 text-center">Messages</h1> */}
      <div className="flex flex-col gap-6">
        {/* Left Side: Tab Buttons */}
        <div className="w-full ">
          <div className="flex flex-row gap-2 sm:gap-3">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={` text-left px-4 py-2.5 font-semibold rounded-md text-base sm:text-lg transition duration-150 ${
                  activeTab === tab.id
                    ? 'bg-[#1B4582] text-white shadow-md'
                    : 'bg-gray-200 text-[#1B4582] hover:bg-gray-300'
                }`}
                role="tab"
                aria-selected={activeTab === tab.id}
                aria-controls={`panel-${tab.id}`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        {/* Right Side: Card Content */}
        <div className="w-full ">
          <div
            id={`panel-${activeTab}`}
            role="tabpanel"
            className="bg-white rounded-xl shadow-md p-6 sm:p-8 text-center"
          >
            <img
              src="img/messageImage.png"
              alt="Empty inbox illustration"
              className="w-32 h-32 sm:w-40 sm:h-40 mx-auto mb-4 object-contain"
              onError={(e) => (e.target.style.display = 'none')} // Hide image if it fails to load
            />
            <h2 className="text-[#1B4582] text-xl sm:text-2xl font-semibold mb-2">No Messages</h2>
            <p className="text-[#000048] text-sm sm:text-base mb-6">
              Looks like your inbox is clear! Go ahead and search for a sitter to start a conversation.
            </p>
            <button
              onClick={handleSearchClick}
              className="bg-[#1B4582] text-white px-6 py-2.5 font-semibold rounded-md hover:bg-[#FF6216] transition duration-150 text-base sm:text-lg"
              aria-label="Search for a dog walker"
            >
              Search Dog Walker!
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Message;